module.exports = __webpack_public_path__ + "static/media/8.95ee3231.JPG";